import {headerCellTitlesOfData} from './static/commonStructures';

export const isFactorLessThanOrEqualToZero = (fieldValue, columName) => {
  if (!columName.includes('Factor')) {
    return false;
  }
  if (!fieldValue) {
    return false;
  }
  const greatThanZero = /^[^-]/i;
  const result = greatThanZero.exec(fieldValue);

  if (!result) {
    return true;
  }
  const parsedNumber = Number(fieldValue);
  return parsedNumber === 0;
};

export const checkFactorPattern = (fieldValue, columName) => {
  if (!columName.includes('Factor')) {
    return false;
  }
  if (!fieldValue) {
    return false;
  }
  const greatThanZeroAndTenDecimals = /^[+|-]?\d+[.]?\d{0,10}$/i;
  const result = greatThanZeroAndTenDecimals.exec(fieldValue);

  if (!result) {
    return true;
  }
};

export const checkRepeatedPrimaryKey = (
  fieldValue,
  tableValues,
  columnName = 'Product code'
) => {
  if (columnName === 'Product code') {
    if (tableValues.length !== 0) {
      const pncList = tableValues.map((values) => {
        return values[0];
      });
      return (
        pncList.filter((pnc) => {
          return pnc === fieldValue;
        }).length > 1
      );
    }
  }
  return false;
};

export const checkFactorValues = (row) => {
  for (let i = 0; i < headerCellTitlesOfData.length; i++) {
    if (headerCellTitlesOfData[i].name.includes('Factor')) {
      if (
        checkFactorPattern(row[i], headerCellTitlesOfData[i].name) ||
        isFactorLessThanOrEqualToZero(row[i], headerCellTitlesOfData[i].name)
      ) {
        return true;
      }
    }
  }
  return false;
};

export const isRowInvalid = (row, tableValues) => {
  return (
    !row[0] ||
    !row[1] ||
    !row[6] ||
    !row[11] ||
    !row[12] ||
    checkRepeatedPrimaryKey(row[0], tableValues) ||
    checkFactorValues(row)
  );
};

export const getDeepCopyOfBidimensionalArray = (originalArray) => {
  return originalArray.map((row) => {
    return row.slice();
  });
};

export const truncateData = (columnDetail, value) => {
  const {maxLength} = columnDetail;
  if (!columnDetail.maxLength || !value) {
    return value;
  }
  return value.substring(0, parseInt(maxLength, 10));
};

export const convertToObject = (row) => {
  const parsedObject = {};
  headerCellTitlesOfData.forEach((column, columnIndex) => {
    parsedObject[column.serializedName] = row[columnIndex];
  });
  return parsedObject;
};
